"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionMetaInfo = void 0;
const core_api_1 = require("@ikegps/core-api");
const theme_1 = require("../../../components/theme");
const username_1 = require("../../../components/user/username");
const index_1 = require("../../../i18n/index");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const index_2 = require("../../../store/index");
const collection_meta_info_style_1 = require("./collection.meta.info.style");
(0, theme_1.addStyles)(collection_meta_info_style_1.Style);
exports.CollectionMetaInfo = {
    view(collection) {
        var _a;
        const summary = index_2.AppStore.CollectionSummary.get(collection.revision);
        var updatedById = collection.updatedBy;
        if (summary != null) {
            updatedById = summary.updatedBy[0];
        }
        const collectedBy = username_1.UserName.view(collection.collectedBy);
        const updatedBy = username_1.UserName.view(updatedById);
        let displayedFormName = collection.schema.displayName;
        if (((_a = collection.schema.displayVersion) !== null && _a !== void 0 ? _a : 0) > 0) {
            displayedFormName = displayedFormName + ` (V${collection.schema.displayVersion})`;
        }
        return (0, mithril_1.m)('div', { className: collection_meta_info_style_1.CSS.container }, [
            exports.CollectionMetaInfo.viewItem(index_1.T.COLLECTION_COLLECTED_AT, services_1.Services.DateTime.formatDateTime(collection.recordedAt)),
            collectedBy != null ? exports.CollectionMetaInfo.viewItem(index_1.T.COLLECTION_COLLECTED_BY, collectedBy) : null,
            exports.CollectionMetaInfo.viewItem(index_1.T.COLLECTION_UPDATED_AT, services_1.Services.DateTime.formatDateTime(collection.updatedAt)),
            updatedBy != null ? exports.CollectionMetaInfo.viewItem(index_1.T.COLLECTION_UPDATED_BY, updatedBy) : null,
            this.viewAssigned(collection),
            exports.CollectionMetaInfo.viewItem(index_1.T.COLLECTION_FORM_NAME, displayedFormName),
        ]);
    },
    viewAssigned(collection) {
        if (!(services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_ASSIGN) || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE))) {
            return null;
        }
        if (collection.assignedTo != null) {
            const assignedTo = username_1.UserName.view(collection.assignedTo);
            return exports.CollectionMetaInfo.viewItem(index_1.T.COLLECTION_ASSIGNED_TO, assignedTo);
        }
        return exports.CollectionMetaInfo.viewItem(index_1.T.COLLECTION_ASSIGNED_TO, (0, index_1.Translate)(index_1.T.COLLECTION_UNASSIGNED));
    },
    viewItem(name, value) {
        return (0, mithril_1.m)('div', { className: collection_meta_info_style_1.CSS.item }, [
            (0, mithril_1.m)('span', { className: collection_meta_info_style_1.CSS.name }, (0, index_1.Translate)(name)),
            (0, mithril_1.m)('span', { className: collection_meta_info_style_1.CSS.value }, value),
        ]);
    },
};
//# sourceMappingURL=collection.meta.info.js.map